import React from 'react'
import { Looks3 } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import NetworkAPI from 'api/faber/NetworkAPI'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import OrbitSession from 'hooks/useCookies'

import NetworksList from './NetworksList'
import preferredNetworks from './preferredNetworks'

export default function NetworkCard({ whitelist }: { whitelist: string }) {
  const faberToken = OrbitSession.get('faberToken')
  const { data: networkDetails } = useQuery(['getNetworkList'], async () =>
    NetworkAPI.getNetworkDetails(whitelist, faberToken)
  )

  const prefNetwork = networkDetails?.data.data.operators ?? preferredNetworks

  return (
    <>
      <Box
        sx={{
          width: '80px',
          height: '80px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: circlesOrbitColorPalette.neutrals[500],
          position: 'absolute',
          ml: '9rem',
          borderRadius: '50%',
          mt: '-70px'
        }}
      >
        <Looks3 sx={{ color: 'white', fontSize: '40px' }} />
      </Box>
      <NormalText
        isBold
        textAlign={'left'}
        sx={{
          fontSize: '24px',
          fontWeight: '700px',
          m: 0
        }}
        text={'Network'}
      />
      <TextColorFontBody
        sx={{
          fontSize: '14px',
          lineHeight: 1,
          color: '#7B8794',
          textAlign: 'left',
          mt: '8px'
        }}
      >
        Check that customer is connected to a network that&apos;s available in
        the country they&apos;re in
      </TextColorFontBody>

      <Stack
        flexDirection={'row'}
        sx={{ mt: '30px', mb: '8px', justifyContent: 'space-between' }}
      >
        <NetworksList preferredNetworks={prefNetwork}>
          <NormalText variant='h1'>
            {' '}
            Click{' '}
            <span
              style={{
                cursor: 'pointer',
                fontWeight: '700',
                textDecoration: 'underline',
                color: '#0000FF'
              }}
            >
              here
            </span>{' '}
            to view the available networks and the countries
          </NormalText>
        </NetworksList>
      </Stack>
    </>
  )
}
